export default __webpack_public_path__ + "static/current-e6f9593a14d11c118b7f36601fc88245.webp";